import React from 'react';
import './App.css';
import HeaderBar from './components/organisms/HeaderBar';
import CustomThemeProvider from './providers/CustomThemeProvider';
import { GlobalStyles } from './consts/GlobalStyle';
import Hero from './components/sections/Hero';
import Skills from './components/sections/Skills';
import { ScreenSizeProvider } from './contexts/ScreenSizeContext';
import Projects from './components/sections/Projects';

import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToHash from './utils/ScrollToHash';

function App() {
  return (
    <ScreenSizeProvider>
      <CustomThemeProvider>
        <Router>
          <ScrollToHash />
          <div className="App">
            <GlobalStyles />
            <HeaderBar />
            <Hero />
            <Projects />
            <Skills />
            {/* <Routes>
            <Route path="/" element={<Projects />} />
            <Route path="/" element={<Skills />} />
          </Routes> */}
          </div>
        </Router>
      </CustomThemeProvider>
    </ScreenSizeProvider>
  );
}

export default App;
